import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background":"url('https://dp3k82tjmkfj0.cloudfront.net/assets/bg-gradient.png')","background-size":"cover","background-position":"center"},
  class: "tw-w-full"
}
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-items-center tw-px-4 tw-pb-6 tw-pt-20 tw-text-center" }
const _hoisted_3 = { class: "tw-text-xl tw-text-white sm:tw-text-2xl md:tw-text-4xl" }
const _hoisted_4 = { class: "tw-mt-2 tw-max-w-md tw-text-white" }
const _hoisted_5 = { class: "tw-flex tw-w-full tw-flex-col tw-items-center tw-pb-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _createTextVNode("Lights, camera, action!")
        ])
      ]),
      _createElementVNode("p", _hoisted_4, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "cta")
    ])
  ]))
}